class VideoPlayer extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    // 存储事件监听器引用，用于清理
    this.eventListeners = {
      posterClick: null,
      videoPause: null,
      videoEnded: null
    };
  }

  static get observedAttributes() {
    return ["src", "poster", "width"];
  }

  connectedCallback() {
    this.render();
    this.attachEventListeners();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      // 先清理旧的事件监听器
      this.detachEventListeners();
      this.render();
      this.attachEventListeners();
    }
  }

  disconnectedCallback() {
    // 组件从 DOM 移除时清理事件监听器
    this.detachEventListeners();
  }

  render() {
    const src = this.getAttribute("src") || "";
    const poster = this.getAttribute("poster") || "";
    const width = this.getAttribute("width") || "85%";

    this.shadowRoot.innerHTML = `
          <style>
            :host {
              display: block;
            }

            .blog-video-container {
              width: ${width};
              margin: 0 auto;
              position: relative;
              aspect-ratio: 16 / 9;
            }

            .blog-video-container video {
              width: 100%;
              height: 100%;
              display: block;
            }

            .blog-poster {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              object-fit: cover;
              margin-block-start: 0;
              cursor: pointer;
              transition: opacity 0.3s ease;
            }

            .blog-poster.hidden {
              opacity: 0;
              pointer-events: none;
            }

            .blog-poster img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              display: block;
            }

            .video-play-button {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 50px;
              height: 50px;
              cursor: pointer;
              transition: transform 0.2s ease;
            }

            .video-play-button:hover {
              transform: translate(-50%, -50%) scale(1.1);
            }
          </style>

          <div class="blog-video-container">
            <video controls>
              <source src="${src}" type="video/mp4">
              Your browser does not support the video tag.
            </video>
            ${
              poster
                ? `
              <div class="blog-poster">
                <img src="${poster}" alt="Video poster">
                <svg class="video-play-button" part="play-button" fill="none" viewBox="0 0 48 48">
                  <path d="M48 24C48 10.745 37.255 0 24 0S0 10.745 0 24s10.745 24 24 24 24-10.745 24-24Z" fill="#ffffff"></path>
                  <path d="M18.578 32.629a.375.375 0 0 1-.578-.316V15.687c0-.297.328-.476.578-.316l12.931 8.314c.23.147.23.483 0 .63L18.578 32.63Z" fill="#323232"></path>
                  <path d="M24 .5C36.979.5 47.5 11.021 47.5 24S36.979 47.5 24 47.5.5 36.979.5 24 11.021.5 24 .5Z" stroke="#323232" stroke-opacity=".12"></path>
                </svg>
              </div>
            `
                : ""
            }
          </div>
        `;
  }

  attachEventListeners() {
    const video = this.shadowRoot.querySelector("video");
    const posterEl = this.shadowRoot.querySelector(".blog-poster");

    if (posterEl && video) {
      // 创建事件处理函数并保存引用
      this.eventListeners.posterClick = () => {
        video.play();
        posterEl.classList.add("hidden");
      };

      this.eventListeners.videoPause = () => {
        if (video.currentTime === 0) {
          posterEl.classList.remove("hidden");
        }
      };

      this.eventListeners.videoEnded = () => {
        posterEl.classList.remove("hidden");
        video.currentTime = 0;
      };

      // 绑定事件监听器
      posterEl.addEventListener("click", this.eventListeners.posterClick);
      video.addEventListener("pause", this.eventListeners.videoPause);
      video.addEventListener("ended", this.eventListeners.videoEnded);
    }
  }

  detachEventListeners() {
    const video = this.shadowRoot?.querySelector("video");
    const posterEl = this.shadowRoot?.querySelector(".blog-poster");

    // 移除事件监听器
    if (posterEl && this.eventListeners.posterClick) {
      posterEl.removeEventListener("click", this.eventListeners.posterClick);
    }
    if (video && this.eventListeners.videoPause) {
      video.removeEventListener("pause", this.eventListeners.videoPause);
    }
    if (video && this.eventListeners.videoEnded) {
      video.removeEventListener("ended", this.eventListeners.videoEnded);
    }

    // 清空引用
    this.eventListeners = {
      posterClick: null,
      videoPause: null,
      videoEnded: null
    };
  }

  // 提供公共方法
  play() {
    const video = this.shadowRoot.querySelector("video");
    const posterEl = this.shadowRoot.querySelector(".blog-poster");
    if (video) {
      video.play();
      if (posterEl) posterEl.classList.add("hidden");
    }
  }

  pause() {
    const video = this.shadowRoot.querySelector("video");
    if (video) video.pause();
  }

  stop() {
    const video = this.shadowRoot.querySelector("video");
    const posterEl = this.shadowRoot.querySelector(".blog-poster");
    if (video) {
      video.pause();
      video.currentTime = 0;
      if (posterEl) posterEl.classList.remove("hidden");
    }
  }
}

// 注册 Web Component
customElements.define("video-player", VideoPlayer);
